import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

export default function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy — Instafrnd</title>
        <meta name="description" content="How Instafrnd (Spynzo (OPC) Private Limited) collects, uses, shares, and protects your personal data." />
        <link rel="canonical" href="https://instafrnd.com/privacy" />
        <meta property="og:url" content="https://instafrnd.com/privacy" />
        <meta property="og:title" content="Privacy Policy — Instafrnd" />
        <meta property="og:description" content="How Instafrnd collects, uses, shares, and protects your personal data." />
      </Helmet>
      <PageHero
        eyebrow="Privacy Policy"
        title="Your privacy, respected."
        subtitle="This policy explains what we collect, why, and the control you have over your data."
      />

      <section className="features">
        <div className="wrap content-narrow prose reveal">
          <p><em>Last updated: 6 August 2026</em></p>
          <p>
            Instafrnd is operated by <strong>Spynzo (OPC) Private Limited</strong> ("Instafrnd",
            "we", "us"). This Privacy Policy describes how we handle your information when you use
            our mobile app and website.
          </p>

          <h3>1. Information we collect</h3>
          <p>
            <strong>You provide:</strong> phone number (for OTP sign-in), name, profile photo,
            bio, gender, date of birth, interests, and identity/KYC documents where verification
            is required. <strong>Automatically:</strong> device and usage data, app interactions,
            and approximate (city-level) location. <strong>Payments:</strong> coin purchases and
            payout details are processed by our payment partners; we store transaction records,
            not full card details.
          </p>

          <h3>2. How we use your information</h3>
          <p>
            To create and secure your account, match and connect you with other members, power
            voice/video calls, rooms and gifting, process payments and payouts, run trust &amp;
            safety and moderation, comply with law, and improve the service.
          </p>

          <h3>3. How we share information</h3>
          <p>
            We share limited data with service providers (hosting, real-time calling, payments,
            analytics, push notifications) strictly to run the service, and with authorities when
            required by law or to prevent harm. Your profile details you choose to make visible are
            shown to other members. <strong>We do not sell your personal data.</strong>
          </p>

          <h3>4. Data retention</h3>
          <p>
            We keep your data while your account is active. When you delete your account, we remove
            your personal data, retaining only limited transaction/legal records for the period
            required by applicable law.
          </p>

          <h3>5. Your rights &amp; account deletion</h3>
          <p>
            You can access or update your information in the app at any time. You may delete your
            account and personal data via <strong>Profile → Settings → Account → Delete Account</strong>,
            or through our <Link to="/delete-account">account deletion page</Link>.
          </p>

          <h3>6. Security</h3>
          <p>
            We use industry-standard safeguards including encryption in transit and access controls.
            No system is perfectly secure, so please keep your login safe and report anything
            suspicious.
          </p>

          <h3>7. Children</h3>
          <p>Instafrnd is for users aged 18 and above. We do not knowingly collect data from minors.</p>

          <h3>8. Changes</h3>
          <p>
            We may update this policy from time to time. Material changes will be notified in the app
            or on this page, with the "Last updated" date revised.
          </p>

          <h3>9. Contact</h3>
          <p>
            Spynzo (OPC) Private Limited<br />
            Sy.No. 31/2, PL Skyship Layout, Seegehalli, Kadugudi, Bangalore, Karnataka - 560067<br />
            Email: <a href="mailto:connect@instafrnd.com">connect@instafrnd.com</a> · Phone:{" "}
            <a href="tel:+919663609788">+91 96636 09788</a>
          </p>
        </div>
      </section>
    </>
  );
}
